import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        minWidth: 0
    }
});
export default stylesheet;
